import Service from "../../AuthService";

const Users = {
    get(page,text) {
        return Service.get("/users?page="+page+"&name="+text);
    },
    show(id) {
        return Service.get("/users/"+id);
    },
    update(data) {
        return Service.put("/users/"+data.id+"?password="+data.password);
    },
    getList() {
        return Service.get("/user-getlist");
    },
    register(data) {
        return Service.post("/user-register",data);
    },
};
export default Users;
